import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { submitAnswer } from "../../../utilities/Answer";
import markdownIt from 'markdown-it';
import mila from "markdown-it-link-attributes";

let md = markdownIt({ html: false, linkify: true, typographer: true, breaks: false });
md.use(mila, { attrs: { target: "_blank", rel: "noopener", } });

export default function Rating(props: any) {
  const { message, currentIndex, count, topMargin }: any = props;
  const design = useSelector((state: any) => state?.design);

  const [rating, setRating] = useState<any[]>([]);

  useEffect(() => {
    setRating(message.options);
  }, [message.options]);

  const handleOptionSelection = (option: any) => {
    submitAnswer(option.value);
  }
  return <>
    <div className="ele-rating-container max-w-80 w-fit">
      <div className={`ele-rating-message-label rounded-tl-xl rounded-tr-xl py-2 px-4 bg-primaryBgColor ${topMargin}`}>
        <p className="prose" dangerouslySetInnerHTML={{ __html: md.render(message.label) }} />
      </div>
      {
        (currentIndex === (count - 1) && (
          <div className="options-container  border-solid border-2 border-t-0 border-primaryBgColor rounded-bl-xl rounded-br-xl" >
            {
              rating.map((option, index) => {
                return <div
                  key={'rating ' + index}
                  className={`ele-rating option flex cursor-pointer justify-center p-2 items-center border-solid border-t-2 border-primaryBgColor hover:bg-primaryBgColor  ${index === rating.length - 1 ? 'hover:rounded-b-lg' : ''}`}
                  onClick={() => handleOptionSelection(option)} >
                  <p id='ele-238' className="text-primaryColor text-center" style={{ color: design?.themeColor }}>{option.value}</p>
                </div>
              })
            }
          </div>
        ))
      }

    </div >
  </>
}